
import './App.css';
import { Routes, Route } from "react-router-dom";
import Loginpage from "./Auth/login"
import Signup from "./Auth/signup"
import Dashboard from './dashboard';
import AdminLogin from "./Admin/Auth/login"


import { useContext } from 'react';
import { ColorContext } from './Admin/dashboard/ColorContext/darkContext';
import Home from './Admin/dashboard/Components/Home/Home';
import Orders from './Admin/dashboard/Components/Orders/Orders';
import AddNew from './Admin/dashboard/Pages/AddNew/AddNew';
import BlogDetail from './Admin/dashboard/Pages/BlogDetail/BlogDetail';
import Blogs from './Admin/dashboard/Pages/Blogs/Blogs';
import Detail from './Admin/dashboard/Pages/Detail/Detail';
import Lists from './Admin/dashboard/Pages/UserLists/UserLists.jsx';
import ProductDetails from './Admin/dashboard/Components/productdetails/index.js';
import Fullproductsdetails from "./dashboard/others/fulldetailsproduct"
import Addnewadmin from "./Admin/dashboard/Pages/addnewadmin.js"
import Proofpayment from "./Admin/dashboard/Components/pendingproof/pendingproof.js"


import './app.scss';





function App() {

  const { darkMode } = useContext(ColorContext);

  return (
    <div className={darkMode ? 'App dark' : 'App'}>
      <Routes>
        <Route path="/" element={<Loginpage />} />

        <Route path="/:token/signup" element={<Signup />} />

        <Route path="dashboard/*" element={<Dashboard />} />
        <Route path="/products-details/:id" element={<Fullproductsdetails />} />

        <Route path="/admin/auth/login" element={<AdminLogin />} />


        <Route path="/admin/dashboard" element={<Home />} />
        <Route path="/admin/dashboard/users" element={<Lists type="user" />}/>

<Route path="/admin/dashboard/users/:userId" element={<Detail />} />



<Route path="/admin/dashboard/orders" element={<Orders />} />


<Route path="/admin/dashboard/products" element={<Lists type="product" />} />

<Route path="/admin/dashboard/addnewproducts" element={<Addnewadmin />} />


<Route path="/admin/dashboard/products/:productId" element={<ProductDetails />} />

<Route path="/admin/dashboard/products/addnew" element={<AddNew />   }/>


<Route path="/admin/dashboard/blogs" element={<Blogs type="blog" />} />

<Route path="/admin/dashboard/:blogId" element={<BlogDetail />} />

<Route path="/admin/dashboard/PayementProof" element={<Proofpayment />} />





        {/* Add more routes as needed */}
      </Routes>


      {/* <Route path="/admin/dashboard" element={<Home />} />


{/* nested routes *
<Route path="/admin/dashboard/users" element={<Lists type="user" />}/>

<Route path="/admin/dashboard/users/:userId" element={<Detail />} />

<Route path="/admin/dashboard/users/addnew" element={ <AddNew inputs={userInpDetails} titlee="Add New User" type="USER"/>}/>


<Route path="/admin/dashboard/orders" element={<Orders />} />


<Route path="/admin/dashboard/products" element={<Lists type="product" />} />

<Route path="/admin/dashboard/products/:productId" element={<Detail />} />

<Route path="/admin/dashboard/products/addnew" element={<AddNew inputs={productInpDetails} titlee="Add New Product"    type="PRODUCT"  />    }/>


<Route path="/admin/dashboard/blogs" element={<Blogs type="blog" />} />

<Route path="/admin/dashboard/:blogId" element={<BlogDetail />} />

<Route path="addnew" element={ <AddNew inputs={blogInputs} titlee="Add New Blog" type="BLOG" />   }/> */}


    </div>
  );
}

export default App;
